/**
 * Black Friday Widget - Działa tylko dla sekcji #main_featured_product
 * Nie koliduje z istniejącym kodem - używa specyficznych selektorów
 */

(function() {
  'use strict';
  
  // Tylko dla Black Friday sekcji
  const BF_SECTION = '#main_featured_product';
  
  class BlackFridayWidget {
    constructor() {
      this.selectedBundle = null;
      this.selectedPaymentType = 'onetime';
      this.sellingPlan = null;
      this.freeProducts = [];
      this.init();
    }
    
    init() {
      // Sprawdź czy jesteśmy na stronie z Black Friday sekcją
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }
    
    setup() {
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      // Pobierz free products
      const freeProductsAttr = section.getAttribute('data-free-products');
      if (freeProductsAttr) {
        try {
          this.freeProducts = JSON.parse(freeProductsAttr).map(id => Number(id));
        } catch (e) {
          // Error parsing free products
        }
      }
      
      // Setup bundle selector
      this.setupBundleSelector();
      
      // Setup default gallery image
      this.setupDefaultGalleryImage();
      
      // Setup subscription selector
      this.setupSubscriptionSelector();
      
      // Setup form submit
      this.setupFormSubmit();
      
      // Update button text
      this.updateButtonText();
    }
    
    setupBundleSelector() {
      const wrapper = document.querySelector(BF_SECTION + ' .bundle_selector_wrapper');
      if (!wrapper) return;
      
      const section = wrapper.closest(BF_SECTION);
      const productInfoContainer = section?.querySelector('.product__info-container');
      
      // Znajdź aktywny bundle lub pierwszy
      const activeBundle = wrapper.querySelector('.bundle_items.active') || 
                           wrapper.querySelector('.bundle_items');
      if (activeBundle) {
        // Ustaw klasę na product__info-container przed wywołaniem selectBundle
        if (productInfoContainer) {
          if (activeBundle.classList.contains('bundle-no-gift-after')) {
            productInfoContainer.classList.add('bundle-no-gift-active');
          } else {
            productInfoContainer.classList.remove('bundle-no-gift-active');
          }
        }
        this.selectBundle(activeBundle);
        // Upewnij się że obrazy są zaktualizowane po inicjalizacji
        setTimeout(() => {
          this.updateSubscriptionWidgetImages(activeBundle);
          this.updateSubscriptionWidgetTexts(activeBundle);
        }, 100);
      }
      
      // Nasłuchuj kliknięć - można kliknąć na bundle_items, bundle_wrapper lub bundle_checkbox
      wrapper.addEventListener('click', (e) => {
        // Sprawdź czy kliknięto na bundle_items bezpośrednio
        let bundleItem = e.target.closest('.bundle_items');
        
        // Jeśli nie, sprawdź czy kliknięto na bundle_wrapper
        if (!bundleItem) {
          const bundleWrapper = e.target.closest('.bundle_wrapper');
          if (bundleWrapper) {
            bundleItem = bundleWrapper.querySelector('.bundle_items');
          }
        }
        
        if (!bundleItem) return;
        
        e.preventDefault();
        e.stopPropagation();
        this.selectBundle(bundleItem);
      });
    }
    
    selectBundle(bundleItem) {
      const wrapper = bundleItem.closest('.bundle_selector_wrapper');
      if (!wrapper) return;
      
      const section = wrapper.closest(BF_SECTION);
      const productInfoContainer = section?.querySelector('.product__info-container');
      
      // Usuń active z wszystkich
      wrapper.querySelectorAll('.bundle_items').forEach(item => {
        item.classList.remove('active');
      });
      
      // Dodaj active do wybranego
      bundleItem.classList.add('active');
      
      // Zarządzaj klasą dla efektu gift :after
      if (productInfoContainer) {
        // Jeśli wybrano bundle #2 lub #3 (mają klasę bundle-no-gift-after), dodaj klasę do product__info-container
        if (bundleItem.classList.contains('bundle-no-gift-after')) {
          productInfoContainer.classList.add('bundle-no-gift-active');
        } else {
          // Jeśli wybrano bundle #1, usuń klasę
          productInfoContainer.classList.remove('bundle-no-gift-active');
        }
      }
      
      // Zapisz dane bundle
      this.selectedBundle = {
        qty: parseInt(bundleItem.getAttribute('bundle_qty')) || 1,
        priceOneTime: bundleItem.getAttribute('otp_price') || '',
        priceSubscription: bundleItem.getAttribute('new_dis_price_sub') || '',
        comparePrice: bundleItem.getAttribute('comp_otp_price') || '',
        discountPrice: bundleItem.getAttribute('discount_price') || '',
        newPriceOne: bundleItem.getAttribute('new_price_one') || ''
      };
      
      // Zaktualizuj quantity w formularzu
      this.updateFormQuantity();
      
      // Zaktualizuj ceny w bundle items (najpierw)
      this.updateBundlePrices();
      
      // Zaktualizuj obraz w galerii
      this.updateGalleryImage(bundleItem);
      
      // Zaktualizuj obrazy w widżecie subskrypcji
      this.updateSubscriptionWidgetImages(bundleItem);
      
      // Zaktualizuj teksty w widżecie subskrypcji
      this.updateSubscriptionWidgetTexts(bundleItem);
      
      // Zaktualizuj ceny w subscription widget (potem)
      setTimeout(() => {
        this.updateSubscriptionPrices();
      }, 50);
    }
    
    setupDefaultGalleryImage() {
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      // Znajdź galerię produktu
      const productInfo = section.querySelector('product-info');
      if (!productInfo) return;
      
      const sectionId = productInfo.getAttribute('data-section');
      const mediaGallery = section.querySelector(`#MediaGallery-${sectionId}`);
      if (!mediaGallery) return;
      
      // Ukryj wszystkie istniejące zdjęcia produktu
      const existingSlides = mediaGallery.querySelectorAll('.slider__slide');
      existingSlides.forEach(slide => {
        slide.style.display = 'none';
      });
      
      // Pobierz customowe zdjęcia
      const defaultImageUrl = section.getAttribute('data-default-gallery-image');
      const bundleImages = this.getBundleImages();
      
      if (!defaultImageUrl || defaultImageUrl === 'null' || defaultImageUrl === '') {
        return;
      }
      
      // Stwórz customowe slajdy w galerii
      this.createCustomGallerySlides(mediaGallery, sectionId, defaultImageUrl, bundleImages);
    }
    
    getBundleImages() {
      const section = document.querySelector(BF_SECTION);
      if (!section) return [];
      
      const bundleItems = section.querySelectorAll('.bundle_items');
      const images = [];
      
      bundleItems.forEach(item => {
        const imageUrl = item.getAttribute('data-bundle-image');
        if (imageUrl && imageUrl !== 'null' && imageUrl !== '') {
          images.push({
            url: imageUrl,
            qty: item.getAttribute('bundle_qty')
          });
        }
      });
      
      return images;
    }
    
    createCustomGallerySlides(mediaGallery, sectionId, defaultImageUrl, bundleImages) {
      // Znajdź listę slajdów
      const sliderList = mediaGallery.querySelector('#Slider-Gallery-' + sectionId);
      if (!sliderList) return;
      
      // Usuń stare customowe slajdy jeśli istnieją
      sliderList.querySelectorAll('.bf-custom-slide').forEach(slide => slide.remove());
      
      // Stwórz slajd dla domyślnego obrazu
      const defaultSlide = this.createSlide(sectionId, defaultImageUrl, 'default', true);
      sliderList.insertBefore(defaultSlide, sliderList.firstChild);
      
      // Stwórz slajdy dla bundle images
      bundleImages.forEach((img, index) => {
        const slide = this.createSlide(sectionId, img.url, `bundle-${img.qty}`, false);
        sliderList.appendChild(slide);
      });
      
      // Zaktualizuj thumbnails
      this.updateCustomThumbnails(mediaGallery, sectionId, defaultImageUrl, bundleImages);
    }
    
    createSlide(sectionId, imageUrl, slideId, isActive) {
      const slide = document.createElement('li');
      slide.className = `product__media-item grid__item slider__slide bf-custom-slide${isActive ? ' is-active' : ''}`;
      slide.id = `Slide-${sectionId}-bf-${slideId}`;
      slide.setAttribute('data-media-id', `${sectionId}-bf-${slideId}`);
      
      const srcset = `
        ${imageUrl.replace('width=2000', 'width=550')} 550w,
        ${imageUrl.replace('width=2000', 'width=1100')} 1100w,
        ${imageUrl.replace('width=2000', 'width=1445')} 1445w,
        ${imageUrl.replace('width=2000', 'width=1680')} 1680w,
        ${imageUrl.replace('width=2000', 'width=2048')} 2048w,
        ${imageUrl.replace('width=2000', 'width=2200')} 2200w,
        ${imageUrl.replace('width=2000', 'width=2890')} 2890w,
        ${imageUrl.replace('width=2000', 'width=4096')} 4096w,
        ${imageUrl} 2000w
      `.trim();
      
      slide.innerHTML = `
        <div class="product-media-container media-type-image media-fit-contain global-media-settings gradient" style="--ratio: 1.0; --preview-ratio: 1.0;">
          <div class="product__media media media--transparent">
            <img
              class="global-media-settings global-media-settings--no-shadow"
              srcset="${srcset}"
              sizes="(min-width: 750px) calc(100vw - 22rem), 1100px"
              src="${imageUrl.replace('width=2000', 'width=1445')}"
              alt=""
              loading="${isActive ? 'eager' : 'lazy'}"
              width="1100"
              height="1100"
              data-media-id="${sectionId}-bf-${slideId}"
            >
          </div>
        </div>
      `;
      
      return slide;
    }
    
    updateCustomThumbnails(mediaGallery, sectionId, defaultImageUrl, bundleImages) {
      // Znajdź kontener thumbnails
      const thumbnailSlider = mediaGallery.querySelector(`#GalleryThumbnails-${sectionId}`);
      if (!thumbnailSlider) {
        return;
      }
      
      const thumbnailList = thumbnailSlider.querySelector(`#Slider-Thumbnails-${sectionId}`);
      if (!thumbnailList) {
        return;
      }
      
      // Ukryj istniejące thumbnails produktu
      thumbnailList.querySelectorAll('.thumbnail-list__item').forEach(thumb => {
        thumb.style.display = 'none';
      });
      
      // Stwórz customowe thumbnails
      const allImages = [{ url: defaultImageUrl, id: 'default' }, ...bundleImages.map(img => ({ url: img.url, id: `bundle-${img.qty}` }))];
      
      allImages.forEach((img, index) => {
        const listItem = document.createElement('li');
        listItem.className = `thumbnail-list__item slider__slide bf-custom-thumbnail-item${index === 0 ? ' thumbnail-list__item--active' : ''}`;
        listItem.id = `Slide-Thumbnails-${sectionId}-bf-${index}`;
        listItem.setAttribute('data-target', `${sectionId}-bf-${img.id}`);
        listItem.setAttribute('data-media-position', index + 1);
        
        const thumbnail = document.createElement('button');
        thumbnail.className = 'thumbnail global-media-settings global-media-settings--no-shadow';
        thumbnail.setAttribute('aria-label', `Go to slide ${index + 1}`);
        thumbnail.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        thumbnail.setAttribute('aria-controls', `GalleryViewer-${sectionId}`);
        
        const thumbImg = document.createElement('img');
        thumbImg.src = img.url.replace('width=2000', 'width=110');
        thumbImg.srcset = `
          ${img.url.replace('width=2000', 'width=110')} 110w,
          ${img.url.replace('width=2000', 'width=220')} 220w
        `.trim();
        thumbImg.alt = '';
        thumbImg.width = 110;
        thumbImg.height = 110;
        thumbImg.loading = 'lazy';
        
        thumbnail.appendChild(thumbImg);
        listItem.appendChild(thumbnail);
        thumbnailList.appendChild(listItem);
        
        // Dodaj event listener do kliknięcia thumbnail
        // MediaGallery.js automatycznie obsługuje kliknięcia przez data-target
        // Ale możemy też dodać własny listener dla lepszej kontroli
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = listItem.getAttribute('data-target');
          this.switchToSlide(sectionId, targetId.replace(`${sectionId}-bf-`, ''));
        });
      });
    }
    
    switchToSlide(sectionId, slideId) {
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      const mediaGallery = section.querySelector(`#MediaGallery-${sectionId}`);
      if (!mediaGallery) return;
      
      // Usuń active z wszystkich slajdów
      mediaGallery.querySelectorAll('.slider__slide').forEach(slide => {
        slide.classList.remove('is-active');
      });
      
      // Dodaj active do wybranego slajdu
      const targetSlide = mediaGallery.querySelector(`#Slide-${sectionId}-bf-${slideId}`);
      if (targetSlide) {
        targetSlide.classList.add('is-active');
      }
      
      // Aktualizuj thumbnails
      const thumbnailList = mediaGallery.querySelector(`#Slider-Thumbnails-${sectionId}`);
      if (thumbnailList) {
        thumbnailList.querySelectorAll('.thumbnail-list__item').forEach(thumb => {
          thumb.classList.remove('thumbnail-list__item--active');
          const thumbButton = thumb.querySelector('button');
          if (thumbButton) {
            thumbButton.setAttribute('aria-current', 'false');
          }
        });
        
        const targetThumb = thumbnailList.querySelector(`[data-target="${sectionId}-bf-${slideId}"]`);
        if (targetThumb) {
          targetThumb.classList.add('thumbnail-list__item--active');
          const thumbButton = targetThumb.querySelector('button');
          if (thumbButton) {
            thumbButton.setAttribute('aria-current', 'true');
          }
        }
      }
    }
    
    updateGalleryImage(bundleItem) {
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      // Pobierz URL obrazu dla bundle
      const bundleImageUrl = bundleItem.getAttribute('data-bundle-image');
      if (!bundleImageUrl || bundleImageUrl === 'null' || bundleImageUrl === '') {
        return;
      }
      
      const bundleQty = bundleItem.getAttribute('bundle_qty');
      const slideId = `bundle-${bundleQty}`;
      
      // Przełącz na odpowiedni slajd
      const productInfo = section.querySelector('product-info');
      if (!productInfo) return;
      
      const sectionId = productInfo.getAttribute('data-section');
      this.switchToSlide(sectionId, slideId);
    }
    
    setupSubscriptionSelector() {
      const subscriptionWrap = document.querySelector(BF_SECTION + ' .product__subs__wrap');
      if (!subscriptionWrap) return;
      
      // Pobierz domyślnie wybrany selling plan przy inicjalizacji
      this.initDefaultSellingPlan(subscriptionWrap);
      
      // Nasłuchuj zmian w radio buttons
      subscriptionWrap.addEventListener('change', (e) => {
        if (e.target.name === 'selling-plan-group') {
          const paymentType = e.target.getAttribute('data-button');
          if (paymentType === 'onetime' || paymentType === 'subscription') {
            this.selectedPaymentType = paymentType;
            
            // Jeśli wybrano subskrypcję, pobierz domyślny selling plan
            if (paymentType === 'subscription') {
              this.initDefaultSellingPlan(subscriptionWrap);
            } else {
              this.sellingPlan = null;
            }
            
            this.updateFormQuantity();
            this.updateBundlePrices();
            // Aktualizuj ceny tylko raz po zmianie
            this.updateSubscriptionPrices();
          }
        }
        
        if (e.target.name === 'current_selling_plan') {
          this.sellingPlan = e.target.value;
          this.updateFormQuantity();
          // Aktualizuj ceny po zmianie selling plan
          this.updateSubscriptionPrices();
        }
      });
      
      // Nasłuchuj zmian w select selling plan frequency
      const sellingPlanSelect = subscriptionWrap.querySelector('#selling_plan_id_select');
      if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener('change', () => {
          this.sellingPlan = sellingPlanSelect.value;
          this.updateFormQuantity();
          // Aktualizuj ceny po zmianie
          this.updateSubscriptionPrices();
        });
      }
      
      // WYŁĄCZONE: Price watcher - nie aktualizujemy w tle
      // this.setupPriceWatcher();
    }
    
    setupPriceWatcher() {
      // WYŁĄCZONE - nie używamy ciągłego monitorowania w tle
      // Ta funkcja została wyłączona aby nie obciążać przeglądarki
      return;
      
      /*
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      // Obserwuj zmiany w elementach cen - używamy bardziej agresywnego podejścia
      const priceObserver = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        
        mutations.forEach((mutation) => {
          // Sprawdź czy zmiana dotyczy tekstu w elementach cen
          if (mutation.type === 'characterData' || mutation.type === 'childList') {
            const target = mutation.target;
            // Jeśli zmiana dotyczy elementu ceny Black Friday, przywróć wartość
            if (target.classList && (
              target.classList.contains('bf-onetime-price') ||
              target.classList.contains('bf-subscription-price') ||
              target.classList.contains('bf-onetime-compare-price') ||
              target.classList.contains('bf-subscription-compare-price') ||
              target.classList.contains('bf-saving-money')
            )) {
              shouldUpdate = true;
            }
            // Sprawdź też dzieci
            if (target.querySelector && target.querySelector('.bf-onetime-price, .bf-subscription-price, .bf-onetime-compare-price, .bf-subscription-compare-price, .bf-saving-money')) {
              shouldUpdate = true;
            }
          }
        });
        
        if (shouldUpdate) {
          // Przywróć nasze wartości po krótkim opóźnieniu
          setTimeout(() => {
            this.updateSubscriptionPrices();
          }, 10);
        }
      });
      
      // Obserwuj wszystkie elementy cen - także w obrębie całej sekcji
      const subscriptionPriceWrapper = section.querySelector('.bf-subscription-price-wrapper');
      const onetimePriceWrapper = section.querySelector('.bf-onetime-price-wrapper');
      
      // Obserwuj całą sekcję, ale filtruj tylko zmiany w elementach BF
      if (section) {
        priceObserver.observe(section, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      
      // Dodatkowo obserwuj bezpośrednio wrappery cen
      if (subscriptionPriceWrapper) {
        priceObserver.observe(subscriptionPriceWrapper, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      
      if (onetimePriceWrapper) {
        priceObserver.observe(onetimePriceWrapper, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      
      // Zapisz observer aby można było go później wyłączyć
      this.priceObserver = priceObserver;
      
      // Dodatkowo: okresowa aktualizacja cen co 200ms aby stale nadpisywać custom.js
      this.priceUpdateInterval = setInterval(() => {
        // Sprawdź czy sekcja Black Friday nadal istnieje
        const section = document.querySelector(BF_SECTION);
        if (section) {
          this.updateSubscriptionPrices();
        } else {
          // Jeśli sekcja nie istnieje, wyczyść interval
          if (this.priceUpdateInterval) {
            clearInterval(this.priceUpdateInterval);
          }
        }
      }, 200);
      */
    }
    
    initDefaultSellingPlan(subscriptionWrap) {
      // Sprawdź czy jest checked radio button
      const checkedRadio = subscriptionWrap.querySelector('input[name="current_selling_plan"]:checked');
      if (checkedRadio) {
        this.sellingPlan = checkedRadio.value;
        return;
      }
      
      // Sprawdź czy jest select z wartością
      const sellingPlanSelect = subscriptionWrap.querySelector('#selling_plan_id_select');
      if (sellingPlanSelect && sellingPlanSelect.value) {
        this.sellingPlan = sellingPlanSelect.value;
        return;
      }
      
      // Sprawdź czy jest pierwszy radio button (jako fallback)
      const firstRadio = subscriptionWrap.querySelector('input[name="current_selling_plan"]');
      if (firstRadio) {
        this.sellingPlan = firstRadio.value;
        return;
      }
      
      // Sprawdź czy jest pierwszy option w select (jako fallback)
      if (sellingPlanSelect && sellingPlanSelect.options.length > 0) {
        this.sellingPlan = sellingPlanSelect.options[0].value;
        return;
      }
    }
    
    updateFormQuantity() {
      const form = document.querySelector(BF_SECTION + ' product-form form');
      if (!form || !this.selectedBundle) return;
      
      // Usuń stare quantity inputs (tylko Black Friday)
      form.querySelectorAll('.bf-quantity-input').forEach(input => input.remove());
      
      // Dodaj nowy quantity input
      const variantInput = form.querySelector('input.product-variant-id');
      if (variantInput && this.selectedBundle.qty) {
        const quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.value = this.selectedBundle.qty;
        quantityInput.className = 'bf-quantity-input';
        variantInput.after(quantityInput);
      }
      
      // Zaktualizuj selling plan
      const sellingPlanInput = form.querySelector('#selling_plane');
      if (sellingPlanInput) {
        sellingPlanInput.value = this.selectedPaymentType === 'subscription' && this.sellingPlan ? this.sellingPlan : '';
      }
      
      const sellingPlanInput2 = form.querySelector('[name="selling_plan"]');
      if (sellingPlanInput2) {
        sellingPlanInput2.value = this.selectedPaymentType === 'subscription' && this.sellingPlan ? this.sellingPlan : '';
      }
    }
    
    updateSubscriptionWidgetImages(bundleItem) {
      const section = document.querySelector(BF_SECTION);
      if (!section || !bundleItem) return;
      
      // Pobierz obrazy z data-attributes
      const onetimeImageUrl = bundleItem.getAttribute('data-onetime-image');
      const subscriptionImageUrl = bundleItem.getAttribute('data-subscription-image');
      
      // Znajdź elementy obrazów w widżecie subskrypcji
      const onetimeImgContainer = section.querySelector('.product__subs__group.one_time .product__subs_img img');
      const subscriptionImgContainer = section.querySelector('.product__subs__group.subscription .product__subs_img img');
      
      // Zaktualizuj obraz dla jednorazowej płatności
      if (onetimeImageUrl && onetimeImageUrl !== 'null' && onetimeImageUrl !== '' && onetimeImgContainer) {
        onetimeImgContainer.src = onetimeImageUrl;
      }
      
      // Zaktualizuj obraz dla subskrypcji
      if (subscriptionImageUrl && subscriptionImageUrl !== 'null' && subscriptionImageUrl !== '' && subscriptionImgContainer) {
        subscriptionImgContainer.src = subscriptionImageUrl;
      }
    }
    
    updateSubscriptionWidgetTexts(bundleItem) {
      const section = document.querySelector(BF_SECTION);
      if (!section || !bundleItem) return;
      
      // Pobierz teksty z data-attributes
      const onetimeText = bundleItem.getAttribute('data-onetime-text');
      const subscriptionText = bundleItem.getAttribute('data-subscription-text');
      
      // Znajdź elementy tekstów w widżecie subskrypcji
      const onetimeTextContainer = section.querySelector('.product__subs__group.one_time .extra-data');
      const subscriptionTextContainer = section.querySelector('.product__subs__group.subscription .extra-data.subscritpion_text');
      
      // Zaktualizuj tekst dla jednorazowej płatności
      if (onetimeText && onetimeText !== 'null' && onetimeText !== '' && onetimeTextContainer) {
        const ulElement = onetimeTextContainer.querySelector('ul');
        if (ulElement) {
          // Jeśli tekst zawiera HTML (richtext), użyj innerHTML, w przeciwnym razie textContent
          const hasHtmlTags = /<[^>]+>/g.test(onetimeText);
          if (hasHtmlTags) {
            ulElement.innerHTML = onetimeText;
          } else {
            ulElement.textContent = onetimeText;
          }
        } else {
          // Jeśli nie ma ul, stwórz go
          const ul = document.createElement('ul');
          const hasHtmlTags = /<[^>]+>/g.test(onetimeText);
          if (hasHtmlTags) {
            ul.innerHTML = onetimeText;
          } else {
            ul.textContent = onetimeText;
          }
          onetimeTextContainer.innerHTML = '';
          onetimeTextContainer.appendChild(ul);
        }
      }
      
      // Zaktualizuj tekst dla subskrypcji
      if (subscriptionText && subscriptionText !== 'null' && subscriptionText !== '' && subscriptionTextContainer) {
        const ulElement = subscriptionTextContainer.querySelector('ul');
        if (ulElement) {
          // Jeśli tekst zawiera HTML (richtext), użyj innerHTML, w przeciwnym razie textContent
          const hasHtmlTags = /<[^>]+>/g.test(subscriptionText);
          if (hasHtmlTags) {
            ulElement.innerHTML = subscriptionText;
          } else {
            ulElement.textContent = subscriptionText;
          }
        } else {
          // Jeśli nie ma ul, stwórz go (ale zachowaj frequency_text jeśli istnieje)
          const frequencyText = subscriptionTextContainer.querySelector('.frequency_text');
          const ul = document.createElement('ul');
          const hasHtmlTags = /<[^>]+>/g.test(subscriptionText);
          if (hasHtmlTags) {
            ul.innerHTML = subscriptionText;
          } else {
            ul.textContent = subscriptionText;
          }
          subscriptionTextContainer.appendChild(ul);
        }
      }
    }
    
    updateSubscriptionPrices() {
      const section = document.querySelector(BF_SECTION);
      if (!section || !this.selectedBundle) return;
      
      const activeBundle = section.querySelector('.bundle_items.active');
      if (!activeBundle) return;
      
      // Zaktualizuj też obrazy przy aktualizacji cen (na wypadek gdyby się coś zmieniło)
      this.updateSubscriptionWidgetImages(activeBundle);
      // Zaktualizuj też teksty przy aktualizacji cen
      this.updateSubscriptionWidgetTexts(activeBundle);
      
      const otpPrice = activeBundle.getAttribute('otp_price') || this.selectedBundle.priceOneTime;
      const compOtpPrice = activeBundle.getAttribute('comp_otp_price') || this.selectedBundle.comparePrice;
      const discountPrice = activeBundle.getAttribute('discount_price') || this.selectedBundle.discountPrice;
      const newDisPriceSub = activeBundle.getAttribute('new_dis_price_sub') || this.selectedBundle.priceSubscription;
      
      // Ceny jednorazowe - użyj nowych klas specyficznych dla Black Friday
      const onetimePriceWrapper = section.querySelector('#main_featured_product .bf-onetime-price-wrapper');
      
      if (otpPrice && onetimePriceWrapper) {
        const onetimePriceEl = onetimePriceWrapper.querySelector('.bf-onetime-price');
        if (onetimePriceEl) {
          onetimePriceEl.textContent = otpPrice;
          
          // Przelicz procent oszczędności dla jednorazowej
          this.updateSavingPercentage(onetimePriceWrapper, otpPrice, compOtpPrice);
        }
      }
      
      if (compOtpPrice && onetimePriceWrapper) {
        const onetimeCompareEl = onetimePriceWrapper.querySelector('.bf-onetime-compare-price');
        if (onetimeCompareEl) {
          onetimeCompareEl.textContent = compOtpPrice;
        }
      }
      
      // Ceny subskrypcji - użyj nowych klas specyficznych dla Black Friday
      const subscriptionPriceWrapper = section.querySelector('#main_featured_product .bf-subscription-price-wrapper');
      
      if (this.selectedPaymentType === 'subscription') {
        // Subskrypcja - użyj ceny za CAŁY bundle z data-subscription-price-total
        // new_dis_price_sub może zawierać cenę za pojedyncze opakowanie (dla bundle #2 i #3)
        // dlatego używamy data-subscription-price-total która zawsze zawiera cenę za cały bundle
        const totalSubscriptionPrice = activeBundle.getAttribute('data-subscription-price-total') || newDisPriceSub;
        
        if (totalSubscriptionPrice && subscriptionPriceWrapper) {
          const subPriceEl = subscriptionPriceWrapper.querySelector('.bf-subscription-price');
          if (subPriceEl) {
            // totalSubscriptionPrice zawiera cenę za cały bundle (np. 239,98 zł za 3 sztuki)
            subPriceEl.textContent = totalSubscriptionPrice;
            
            // Przelicz procent oszczędności na podstawie rzeczywistych cen (cały bundle)
            this.updateSavingPercentage(subscriptionPriceWrapper, totalSubscriptionPrice, compOtpPrice);
          }
        }
      } else {
        // Jednorazowa - użyj discount_price dla subscription widget
        if (discountPrice && subscriptionPriceWrapper) {
          const subPriceEl = subscriptionPriceWrapper.querySelector('.bf-subscription-price');
          if (subPriceEl) {
            subPriceEl.textContent = discountPrice;
            
            // Przelicz procent oszczędności dla jednorazowej
            this.updateSavingPercentage(subscriptionPriceWrapper, discountPrice, compOtpPrice);
          }
        }
      }
      
      // Cena porównawcza subskrypcji - użyj nowej klasy
      if (compOtpPrice && subscriptionPriceWrapper) {
        const subCompareEl = subscriptionPriceWrapper.querySelector('.bf-subscription-compare-price');
        if (subCompareEl) {
          subCompareEl.textContent = compOtpPrice;
        }
      }
      
      // Aktualizuj serving text w pre_serving_wrapper - użyj specyficznego selektora dla Black Friday
      const servingText = activeBundle.querySelector('.serving_text');
      if (servingText) {
        const servingTextEl = section.querySelector('#main_featured_product .pre_serving_wrapper .text.ser_per');
        if (servingTextEl) {
          servingTextEl.textContent = servingText.textContent.trim();
        }
      }
      
      // Aktualizuj cenę w las_data - użyj specyficznego selektora dla Black Friday
      const lasDataEl = section.querySelector('#main_featured_product .pre_serving_wrapper .text.las_data');
      if (lasDataEl) {
        if (this.selectedPaymentType === 'subscription') {
          // Użyj ceny za cały bundle, a potem podziel przez ilość aby pokazać cenę za serving
          const totalPrice = activeBundle.getAttribute('data-subscription-price-total') || newDisPriceSub;
          const bundleQty = parseInt(activeBundle.getAttribute('bundle_qty')) || 1;
          
          if (totalPrice) {
            // Wyciągnij liczbę z tekstu ceny i podziel przez ilość
            const priceStr = totalPrice.toString().replace(/[^\d,]/g, '').replace(',', '.');
            const priceNum = parseFloat(priceStr);
            
            if (!isNaN(priceNum) && bundleQty > 0) {
              const pricePerServing = priceNum / bundleQty;
              // Formatuj z powrotem jako PLN
              const formattedPrice = pricePerServing.toFixed(2).replace('.', ',') + ' zł';
              lasDataEl.textContent = formattedPrice + ' / serving';
            } else {
              lasDataEl.textContent = totalPrice + ' / serving';
            }
          }
        } else {
          const price = activeBundle.getAttribute('new_price_one') || otpPrice;
          if (price) {
            lasDataEl.textContent = price + ' / serving';
          }
        }
      }
    }
    
    updateSavingPercentage(priceWrapper, currentPriceText, comparePriceText) {
      if (!priceWrapper || !currentPriceText || !comparePriceText) {
        return;
      }
      
      try {
        // Wyciągnij liczby z tekstu (usuń wszystko oprócz cyfr i przecinka, zamień przecinek na kropkę)
        // Przykład: "76,66 zł" -> "76.66", "419,97 zł" -> "419.97"
        const currentPriceStr = currentPriceText.toString().trim().replace(/[^\d,]/g, '').replace(',', '.');
        const comparePriceStr = comparePriceText.toString().trim().replace(/[^\d,]/g, '').replace(',', '.');
        
        const currentPrice = parseFloat(currentPriceStr);
        const comparePrice = parseFloat(comparePriceStr);
        
        if (isNaN(currentPrice) || isNaN(comparePrice) || comparePrice <= 0 || currentPrice <= 0) {
          return;
        }
        
        // Oblicz procent oszczędności: (cena_porównawcza - cena_aktualna) / cena_porównawcza * 100
        const saving = comparePrice - currentPrice;
        const savingPercentage = Math.round((saving / comparePrice) * 100);
        
        if (savingPercentage < 0) {
          return;
        }
        
        // Zaktualizuj element saving-money - użyj nowej klasy bf-saving-money
        const savingEl = priceWrapper.querySelector('.bf-saving-money');
        if (savingEl) {
          savingEl.textContent = `OSZCZĘDZASZ ${savingPercentage}%`;
          // Upewnij się że element jest widoczny (może być ukryty przez Liquid)
          savingEl.style.display = '';
        } else {
          // Fallback na starą klasę dla kompatybilności
          const fallbackSavingEl = priceWrapper.querySelector('.saving-money');
          if (fallbackSavingEl) {
            fallbackSavingEl.textContent = `OSZCZĘDZASZ ${savingPercentage}%`;
            fallbackSavingEl.style.display = '';
          }
        }
      } catch (error) {
        // Error calculating saving percentage
      }
    }
    
    updateBundlePrices() {
      const wrapper = document.querySelector(BF_SECTION + ' .bundle_selector_wrapper');
      if (!wrapper) return;
      
      const bundleWrappers = wrapper.querySelectorAll('.bundle_wrapper');
      bundleWrappers.forEach(bundleWrapper => {
        const bundleItem = bundleWrapper.querySelector('.bundle_items');
        if (!bundleItem) return;
        
        // Użyj nowej klasy .bf-bundle-price
        const priceElement = bundleWrapper.querySelector('.bf-bundle-price');
        if (!priceElement) return;
        
        if (this.selectedPaymentType === 'subscription') {
          // Wymuś użycie ceny subskrypcji z data-attribute (który pochodzi z zapleczu)
          const subPrice = priceElement.getAttribute('data-bundle-price-subscription');
          if (subPrice) {
            priceElement.textContent = subPrice + ' / op.';
          } else {
            // Fallback na stary atrybut
            const fallbackPrice = bundleItem.getAttribute('new_dis_price_sub');
            if (fallbackPrice) {
              priceElement.textContent = fallbackPrice + ' / op.';
            }
          }
        } else {
          // Jednorazowa - użyj z data-attribute
          const otpPrice = priceElement.getAttribute('data-bundle-price-one-time');
          if (otpPrice) {
            priceElement.textContent = otpPrice + ' / op.';
          } else {
            // Fallback na stary atrybut
            const fallbackPrice = bundleItem.getAttribute('new_price_one');
            if (fallbackPrice) {
              priceElement.textContent = fallbackPrice + ' / op.';
            }
          }
        }
      });
    }
    
    setupFormSubmit() {
      // Przechwyć submit na document level z capture phase
      document.addEventListener('submit', (e) => {
        const form = e.target.closest ? e.target.closest('form') : e.target;
        if (!form || form.tagName !== 'FORM') return;
        
        const section = form.closest(BF_SECTION);
        if (!section) return;
        
        // Zatrzymaj propagację PRZED product-form listenerem
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        
        this.handleSubmit(form);
      }, true); // capture phase
    }
    
    async handleSubmit(form) {
      // Znajdź przycisk submit w sekcji Black Friday
      const section = form.closest(BF_SECTION);
      if (!section) return;
      
      const submitButton = section.querySelector('[type="submit"][name="add"]');
      
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('loading');
      }
      
      try {
        // NAJPIERW: Sprawdź i wyczyść koszyk oraz kody rabatowe jeśli są
        await this.ensureCleanCart();
        
        // Przygotuj formData
        const formData = new FormData(form);
        
        // Upewnij się że quantity jest ustawione
        if (this.selectedBundle && this.selectedBundle.qty) {
          formData.set('quantity', this.selectedBundle.qty);
        }
        
        // Upewnij się że selling_plan jest ustawione dla subskrypcji
        if (this.selectedPaymentType === 'subscription') {
          // [ISTOTNE] Dla subskrypcji upewnij się że używasz właściwego ID wariantu z produktu subskrypcyjnego
          const subscriptionWidget = section.querySelector('.product__subs__wrap');
          if (subscriptionWidget) {
            const subVariantIdInput = subscriptionWidget.querySelector('[data-sub-variant-id]');
            if (subVariantIdInput && subVariantIdInput.value) {
              // Ustaw ID wariantu produktu subskrypcyjnego w formData
              formData.set('id', subVariantIdInput.value);
              // Również zaktualizuj w formularzu na wypadek gdyby był używany później
              const formIdInput = form.querySelector('input[name="id"]');
              if (formIdInput) {
                formIdInput.value = subVariantIdInput.value;
              }
            }
          }
          // Najpierw sprawdź czy mamy selling plan w obiekcie
          let sellingPlanId = this.sellingPlan;
          
          // Jeśli nie ma, spróbuj pobrać z formularza
          if (!sellingPlanId) {
            const formSellingPlan = form.querySelector('input[name="current_selling_plan"]:checked');
            if (formSellingPlan) {
              sellingPlanId = formSellingPlan.value;
            } else {
              const formSelect = form.querySelector('#selling_plan_id_select');
              if (formSelect && formSelect.value) {
                sellingPlanId = formSelect.value;
              }
            }
          }
          
          // Jeśli nadal nie ma, spróbuj z ukrytych inputów w formularzu
          if (!sellingPlanId) {
            const hiddenInput = form.querySelector('[name="selling_plan"]');
            if (hiddenInput && hiddenInput.value) {
              sellingPlanId = hiddenInput.value;
            }
          }
          
          const hiddenInput2 = form.querySelector('#selling_plane');
          if (hiddenInput2 && hiddenInput2.value) {
            sellingPlanId = hiddenInput2.value;
          }
          
          if (sellingPlanId) {
            formData.set('selling_plan', sellingPlanId);
          } else {
            this.showError('Proszę wybrać częstotliwość dostawy');
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.classList.remove('loading');
            }
            return;
          }
        }
        
        // Pobierz stałą cenę jeśli jest ustawiona (różna dla subskrypcji i jednorazowych)
        const activeBundle = section.querySelector('.bundle_items.active');
        let fixedPrice = null;
        let fixedComparePrice = null;
        
        if (activeBundle) {
          // Dla subskrypcji użyj subscription price, dla jednorazowych regular price
          if (this.selectedPaymentType === 'subscription') {
            fixedPrice = activeBundle.getAttribute('data-fixed-subscription-price');
          } else {
            fixedPrice = activeBundle.getAttribute('data-fixed-price');
          }
          
          fixedComparePrice = activeBundle.getAttribute('data-fixed-compare-price');
          
          // Dodaj properties z informacją o cenie (do przyszłego użycia)
          if (fixedPrice && fixedPrice !== 'null' && fixedPrice !== '') {
            formData.set('properties[_fixed_price]', fixedPrice);
            
            // Dodaj odpowiednią cenę sformatowaną
            if (this.selectedPaymentType === 'subscription') {
              formData.set('properties[_fixed_price_formatted]', activeBundle.getAttribute('new_dis_price_sub'));
            } else {
              formData.set('properties[_fixed_price_formatted]', activeBundle.getAttribute('otp_price'));
            }
          }
          
          if (fixedComparePrice && fixedComparePrice !== 'null' && fixedComparePrice !== '') {
            formData.set('properties[_fixed_compare_price]', fixedComparePrice);
            formData.set('properties[_fixed_compare_price_formatted]', activeBundle.getAttribute('comp_otp_price'));
          }
        }
        
        // Dodaj produkt do koszyka
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        const data = await response.json();
        
        if (data.status) {
          // Błąd
          this.showError(data.description || 'Wystąpił błąd');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('loading');
          }
          return;
        }
        
        // Poczekaj chwilę aby Shopify przetworzył dodanie produktu
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // NAJPIERW: Dodaj gratisy (jeśli potrzebne)
        const shouldAddFreeProducts = this.shouldAddFreeProducts();
        
        if (shouldAddFreeProducts) {
          await this.addFreeProducts();
          // Poczekaj chwilę po dodaniu gratisów
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        
        // POTEM: Zastosuj discount code (PO dodaniu wszystkich produktów, aby obejmował wszystko)
        // Dla subskrypcji używamy osobnych kodów (BF_BUNDLE_X_SUB)
        // Dla jednorazowych używamy standardowych kodów (BF_BUNDLE_X)
        if (fixedPrice && fixedPrice !== 'null' && fixedPrice !== '' && fixedPrice !== null) {
          await this.applyDiscountCode(fixedPrice, fixedComparePrice);
          // Poczekaj chwilę po zastosowaniu kodu przed przekierowaniem
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        
        // Przekieruj do checkout
        window.location.href = '/checkout';
        
      } catch (error) {
        this.showError('Wystąpił błąd podczas przetwarzania zamówienia');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        }
      }
    }
    
    async applyDiscountCode(fixedPrice, fixedComparePrice) {
      try {
        // Poczekaj chwilę aby upewnić się że koszyk jest zaktualizowany
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // Pobierz koszyk
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        if (!cartData.items || cartData.items.length === 0) {
          return;
        }
        
        const bundleQty = this.selectedBundle ? this.selectedBundle.qty : 1;
        
        // Oblicz aktualną cenę w koszyku (w groszach)
        // Sumuj wszystkie produkty (główny + gratisy)
        let totalPrice = 0;
        cartData.items.forEach(item => {
          totalPrice += item.price * item.quantity;
        });
        
        const targetPrice = parseInt(fixedPrice);
        
        // Mapowanie bundle quantity do kodów rabatowych
        // Dla subskrypcji używamy osobnych kodów (_SUB), dla jednorazowych standardowych
        const discountCodes = this.selectedPaymentType === 'subscription' ? {
          '1': 'BF_BUNDLE_1_SUB',
          '3': 'BF_BUNDLE_3_SUB', 
          '5': 'BF_BUNDLE_5_SUB'
        } : {
          '1': 'BF_BUNDLE_1',
          '3': 'BF_BUNDLE_3', 
          '5': 'BF_BUNDLE_5'
        };
        
        const codeToApply = discountCodes[bundleQty.toString()];
        
        if (!codeToApply) {
          return;
        }
        
        // Zastosuj kod rabatowy przez Cart API
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: codeToApply
          })
        });
        
        const updateData = await updateResponse.json();
        
        if (updateData.errors) {
          return;
        }
        
        // Poczekaj chwilę aby Shopify przetworzył kod
        await new Promise(resolve => setTimeout(resolve, 300));
        
      } catch (error) {
        // Nie blokuj checkoutu jeśli nie udało się zastosować zniżki
      }
    }
    
    shouldAddFreeProducts() {
      // Gratisy dla wszystkich oprócz bundle 1 jednorazowo
      if (!this.selectedBundle) return false;
      
      // Bundle 1 jednorazowo - NIE ma gratisów
      if (this.selectedBundle.qty === 1 && this.selectedPaymentType === 'onetime') {
        return false;
      }
      
      // Wszystkie pozostałe - TAK mają gratisy
      return true;
    }
    
    async ensureCleanCart() {
      try {
        // KROK 1: Sprawdź aktualny stan koszyka
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        const hasItems = cartData.items && cartData.items.length > 0;
        const hasDiscountCodes = cartData.discount_codes && cartData.discount_codes.length > 0;
        const hasDiscount = cartData.total_discount && cartData.total_discount > 0;
        
        // Jeśli koszyk jest już czysty, nie rób nic
        if (!hasItems && !hasDiscountCodes && !hasDiscount) {
          return;
        }
        
        // KROK 2: Usuń wszystkie pozycje z koszyka (jeśli są)
        if (hasItems) {
          // Usuń wszystkie pozycje sekwencyjnie (bardziej niezawodne niż równolegle)
          for (const item of cartData.items) {
            try {
              const changeResponse = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              });
              
              const changeData = await changeResponse.json();
              
              if (changeData.errors) {
                // Error removing item
              }
            } catch (err) {
              // Error removing item
            }
          }
          
          // Poczekaj chwilę aby Shopify przetworzył zmiany
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        
        // KROK 3: Wyczyść kody rabatowe (zawsze, nawet jeśli nie było produktów)
        if (hasDiscountCodes || hasDiscount) {
          try {
            const updateResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                discount: ''
              })
            });
            
            const updateData = await updateResponse.json();
            
            if (updateData.errors) {
              // Error clearing discount codes
            }
            
            // Poczekaj chwilę
            await new Promise(resolve => setTimeout(resolve, 200));
          } catch (err) {
            // Error clearing discount codes
          }
        }
        
        // KROK 4: Zweryfikuj że koszyk jest pusty i bez kodów
        const verifyResponse = await fetch('/cart.js');
        const verifyData = await verifyResponse.json();
        
        const stillHasItems = verifyData.items && verifyData.items.length > 0;
        const stillHasCodes = verifyData.discount_codes && verifyData.discount_codes.length > 0;
        
        if (stillHasItems || stillHasCodes) {
          if (stillHasItems) {
            // Spróbuj użyć /cart/clear.js jako fallback
            try {
              await fetch('/cart/clear.js', {
                method: 'POST'
              });
              
              // Poczekaj i sprawdź jeszcze raz
              await new Promise(resolve => setTimeout(resolve, 300));
              const finalCheck = await fetch('/cart.js');
              const finalData = await finalCheck.json();
              
              if (finalData.items && finalData.items.length > 0) {
                throw new Error('Failed to clear cart completely');
              }
            } catch (e) {
              throw new Error('Failed to clear cart');
            }
          }
          
          if (stillHasCodes) {
            // Spróbuj jeszcze raz wyczyścić kody
            try {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  discount: ''
                })
              });
              await new Promise(resolve => setTimeout(resolve, 200));
            } catch (e) {
              // Failed to clear discount codes on retry
            }
          }
        }
        
      } catch (error) {
        // Rzuć błąd aby zatrzymać proces - lepiej nie dodawać produktów do brudnego koszyka
        throw error;
      }
    }
    
    async addFreeProducts() {
      if (!this.freeProducts || this.freeProducts.length === 0) {
        return;
      }
      
      try {
        // Sprawdź co już jest w koszyku
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        const cartItemIds = cartData.items.map(item => item.variant_id.toString());
        const freeProductsToAdd = this.freeProducts.filter(id => 
          !cartItemIds.includes(id.toString())
        );
        
        if (freeProductsToAdd.length === 0) {
          return;
        }
        
        // Dodaj gratisy
        const freeItems = freeProductsToAdd.map(id => ({ id: id, quantity: 1 }));
        
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: freeItems })
        });
        
        const addData = await addResponse.json();
        
        if (addData.status) {
          // Error adding free products
        }
        
      } catch (error) {
        // Error adding free products
      }
    }
    
    showError(message) {
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      const errorWrapper = section.querySelector('.product-form__error-message-wrapper');
      if (errorWrapper) {
        const errorMessage = errorWrapper.querySelector('.product-form__error-message');
        if (errorMessage) {
          errorMessage.textContent = message;
          errorWrapper.hidden = false;
        }
      }
    }
    
    updateButtonText() {
      const section = document.querySelector(BF_SECTION);
      if (!section) return;
      
      const submitButton = section.querySelector('[type="submit"][name="add"]');
      if (!submitButton) return;
      
      const buttonSpan = submitButton.querySelector('span');
      if (buttonSpan) {
        buttonSpan.textContent = 'Przejdź do płatności';
      }
      
      // Użyj MutationObserver aby zmienić tekst jeśli przycisk się zmieni
      const observer = new MutationObserver(() => {
        const span = submitButton.querySelector('span');
        if (span && submitButton.disabled === false) {
          span.textContent = 'Przejdź do płatności';
        }
      });
      
      observer.observe(submitButton, {
        childList: true,
        subtree: true
      });
      
      setTimeout(() => observer.disconnect(), 5000);
    }
  }
  
  // Inicjalizuj widget tylko jeśli istnieje sekcja Black Friday
  if (document.querySelector(BF_SECTION)) {
    new BlackFridayWidget();
  }
})();

